import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderNoteDto } from './order-note.dto';

@Injectable({ providedIn: 'root' })
export class OrderNotesProvider {
  constructor(private http: HttpClient) {}

  getNotes(orderId: number): Observable<OrderNoteDto[]> {
    const url = `/api/production-orders/${orderId}/notes`;
    return this.http.get<OrderNoteDto[]>(url);
  }

  createNote(orderId: number, content: string): Observable<OrderNoteDto> {
    const url = `/api/production-orders/${orderId}/notes`;
    return this.http.post<OrderNoteDto>(url, { content });
  }
}
